import { format } from 'date-fns';
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { InlineEdit } from './inline-edit';
import 'react-datepicker/dist/react-datepicker.css';

type InlineDateEditProps = {
  value: Date | null;
  onChange: (value: Date | null) => void;
  placeholder?: string;
  displayFormat?: string;
  small?: boolean;
  editOn?: 'click' | 'hover' | 'focus';
  disabled?: boolean;
  className?: string;
  dateFormat?: string;
  [key: string]: unknown; // Allow other ReactDatePicker props
};

export function InlineDateEdit({
  value,
  onChange,
  placeholder = 'Select date',
  displayFormat = 'MM/dd/yyyy',
  small = false,
  editOn = 'hover',
  disabled = false,
  className,
  dateFormat,
  ...datePickerProps
}: InlineDateEditProps) {
  const handleDisplay = (date: Date | null) => {
    if (date) {
      return format(date, displayFormat);
    }
    return placeholder;
  };

  const datePickerClassName = small
    ? 'datepicker-input datepicker-input-small'
    : 'datepicker-input';
  const wrapperClassName = small ? 'datepicker-wrapper tw:!mt-0' : 'datepicker-wrapper';

  return (
    <InlineEdit<Date | null>
      value={value}
      onChange={onChange}
      renderDisplay={handleDisplay}
      renderEditor={(date, handleChange, onBlur, onFocus) => (
        <ReactDatePicker
          className={datePickerClassName}
          wrapperClassName={wrapperClassName}
          selected={date}
          onChange={(newDate) => {
            handleChange(newDate);
          }}
          onSelect={(selectedDate) => {
            handleChange(selectedDate);
            setTimeout(() => {
              onBlur();
            }, 0);
          }}
          onFocus={onFocus}
          placeholderText={placeholder}
          disabled={disabled}
          dateFormat={dateFormat}
          {...datePickerProps}
        />
      )}
      editOn={editOn}
      disabled={disabled}
      className={className}
    />
  );
}
